import { useBaseAPI } from 'apiServices/baseAPI';
import { oids, endpoints, currentMode } from 'configs';

export function useDiagnosticReportAPI({
  resourceId,
  organizationId,
  purposeOfUse,
  subjectId,
  subjectToken,
}) {
  return useBaseAPI(
    {
      method: 'GET',
      route: `${
        endpoints.MHD.split(`${endpoints.XDSB_domain}/`)[1]
      }/DiagnosticReport?subject%3APatient.identifier=urn:oid:${
        resourceId.length === 11 ? oids.cpf : oids.cns
      }%7C${resourceId}&status=registered,partial,preliminary,modified,final,amended,corrected,appended&_include=DiagnosticReport:based-on&_count=5&_sort=-issued`,
      additionalHeaders: {
        purposeofuse: purposeOfUse || 'Atendimento',
        ...(organizationId && { 'organization-id': organizationId }),
        ...(subjectId && { 'subject-id': subjectId }),
        ...(resourceId
          && currentMode === 'aghu' && { 'resource-id': resourceId }),
        ...(subjectToken && { authorization: `Bearer ${subjectToken}` }),
        ...(subjectToken && { 'x-user-token': subjectToken }),
      },
    },
    !resourceId,
  );
}
